import {
	USERS_BY_GROUP_FETCH_REQUEST,
	USERS_BY_GROUP_FETCH_FAILURE,
	USERS_BY_GROUP_FETCH_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	groups: {},
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case USERS_BY_GROUP_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
			};

		case USERS_BY_GROUP_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
			};

		case USERS_BY_GROUP_FETCH_SUCCESS:
			const { groupId, ids } = payload;

			return {
				...state,
				isFetching: false,
				groups: {
					...state.groups,
					[groupId]: ids,
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/usersByGroup.js